module.exports = __webpack_public_path__ + "img/C05TechBolster_ua.b60f4d4c.webp";